// Cart drawer + cart page: when a shopper tries to raise a stock-tracked line above its available units
// ([data-stock-max], set in snippets/cart-line-item.liquid), show that line's red "Maximum quantity" note.
// The + tap at the limit is cancelled (no cart request); typed values are clamped by s-cart via data-qty-max.
// Cart HTML re-renders after updates, so recently flagged lines are re-shown after each refresh.
(() => {
  const flagged = new Map(); // lineKey -> expiry time
  const SHOW_MS = 6000;

  const noteFor = (lineKey) =>
    [...document.querySelectorAll("[data-qty-limit-note]")].filter((el) => el.dataset.lineKey === lineKey);

  const show = (lineKey) => {
    flagged.set(lineKey, Date.now() + SHOW_MS);
    noteFor(lineKey).forEach((el) => (el.hidden = false));
  };

  const hide = (lineKey) => {
    flagged.delete(lineKey);
    noteFor(lineKey).forEach((el) => (el.hidden = true));
  };

  const displayFor = (lineKey) =>
    [...document.querySelectorAll("[data-quantity-display]")].find((el) => el.dataset.lineKey === lineKey);

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest?.("button[data-delta]");
      if (!button) return;
      const lineKey = button.dataset.lineKey;
      const delta = parseInt(button.dataset.delta, 10) || 0;
      const max = parseInt(button.dataset.stockMax, 10);
      if (!lineKey || isNaN(max)) return;
      const current = parseInt(displayFor(lineKey)?.value, 10) || 0;
      if (delta > 0 && current + delta > max) {
        event.preventDefault(); // cancels the --update-quantity command: nothing to change
        event.stopImmediatePropagation();
        show(lineKey);
      } else if (delta < 0) {
        hide(lineKey);
      }
    },
    true,
  );

  document.addEventListener(
    "change",
    (event) => {
      const input = event.target;
      if (!input.matches?.("[data-quantity-display][data-stock-max]")) return;
      const max = parseInt(input.dataset.stockMax, 10);
      const value = parseInt(input.value, 10);
      if (isNaN(max) || isNaN(value)) return;
      if (value > max) show(input.dataset.lineKey);
      else hide(input.dataset.lineKey);
    },
    true,
  );

  // Re-apply after the cart re-renders.
  new MutationObserver(() => {
    const now = Date.now();
    for (const [lineKey, expiry] of flagged) {
      if (expiry < now) {
        flagged.delete(lineKey);
        continue;
      }
      noteFor(lineKey).forEach((el) => {
        if (el.hidden) el.hidden = false;
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
